@if (loader.isLoading()) {
<div
   class="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-black/10 backdrop-blur-md transition-all duration-300">

   <div class="relative flex justify-center items-center h-24 mb-6">
      <div class="absolute inset-0 bg-main/20 blur-2xl rounded-full animate-pulse scale-150"></div>

      <svg width="200" height="60" viewBox="0 0 160 40" fill="none" xmlns="http://www.w3.org/2000/svg"
         class="text-main relative z-10 drop-shadow-md">
         <path d="M 10 30 V 10 L 20 22 L 30 10 V 30" stroke="currentColor" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" class="mento-letter" />

         <path d="M 55 10 H 40 V 30 H 55 M 40 20 H 50" stroke="currentColor" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" class="mento-letter" />

         <path d="M 65 30 V 10 L 85 30 V 10" stroke="currentColor" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" class="mento-letter" />

         <path d="M 95 10 H 115 M 105 10 V 30" stroke="currentColor" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" class="mento-letter" />

         <path d="M 135 10 A 10 10 0 1 1 135 30 A 10 10 0 1 1 135 10" stroke="currentColor" stroke-width="4"
            stroke-linecap="round" stroke-linejoin="round" class="mento-letter" />
      </svg>
   </div>

   <div class="flex flex-col items-center relative z-10">
      <span class="text-main font-bold text-xl tracking-[0.3em] uppercase animate-pulse">
         {{ 'common.loading' | translate }}<span class="typing-dots">{{ '....' }}</span>
      </span>
   </div>

</div>
}